<template>
  <div class='ui-slider'>
    <label
      class="title"
      v-bind:for='slider.instanceGuid'
      v-text='(slider.nickName.length <= 0) ? "Unknown" : slider.nickName'
    ></label>
    <div class='item'>
      <input
        ref='range'
        type='range'
        v-bind:value='slider.value'
        v-bind:min='slider.min'
        v-bind:max='slider.max'
        v-bind:step='step'
        @input='onChangeRange'
      />
      <input
        ref='number'
        type='number'
        v-bind:value='slider.value'
        v-bind:id='slider.isntanceGuid'
        v-bind:min='slider.min'
        v-bind:max='slider.max'
        v-bind:step='step'
        @input='onChangeNumber'
        @change='onChangeNumber'
      />
      <span>mm</span>
    </div>
  </div>
</template>

<script>

import { debounce } from 'lodash';
import UIBase from './UIBase.vue';

export default {
  name: 'Slider',
  extends: UIBase,
  components: {
  },
  props: {
    slider: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
    };
  },
  computed: {
    step: {
      get () {
        if (this.slider.interval > 0) {
          return this.slider.interval;
        }
        return 1 / Math.pow(10, this.slider.digits);
      }
    }
  },
  mounted () {
    this.onChange(this.slider.value);
  },
  methods: {
    updateQuery (key, ref) {
      if (!key || !ref) return;
      let value = this.$refs[ref].value;
      const url = new URL(location.href);
      url.searchParams.set(key, value);
      history.pushState(null, '', url);
    },

    onChangeRange (e) {
      let v = Number(this.$refs.range.value);
      this.debounceOnChange(v);
      this.updateQuery(this.slider.instanceGuid, 'range')
    },

    onChangeNumber (e) {
      let v = Number(this.$refs.number.value);
      this.debounceOnChange(v);
      this.updateQuery(this.slider.instanceGuid, 'number')
    },

    debounceOnChange: debounce(function (v) {
      this.onChange(v);
    }, 75),

    onChange (v) {
      this.$refs.range.value = this.$refs.number.value = v;
      let n = Number(v);
      if (this.slider.value !== n) {
        this.slider.change(n);
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Slider.vue